export default __webpack_public_path__ + "static/media/calender-icon.f993a3e7.svg";